import React, { useState, useEffect, useRef } from 'react'
import './ServicesCharts.css'
//components
import DashboardFilter from '../fragments/DashboardFilter'
import Donut from '../../../components/Charts/Donut/Donut'
//utils
import { formatShortDate, getMonth } from '../../../utils/utils';
//services
import { dashboardService } from '../../../services/Dashboard';
import {customer} from '../../../services/customer';
//import { chatService } from '../../../services/Chat';

const ServicesCharts = () => {
  const chartRef = useRef(null);
  const customColors = ['#15B79E', '#0E5F79', '#D72638', '#F2994A', '#C5E1A5'];
  const [services, setServices] = useState([]);
  const [requests, setRequests] = useState([])
  const [customers, setCustomers] = useState([])
  const [users, setUsers] = useState([])
  //const [chats, setChats] = useState([])

  useEffect(() => {
    fetchServices();
    fetchRequests();
    fetchCustomers();
    //fetchChats();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await customer.getList({page: 1, items_per_page: 100});
      if(response.status === "success"){
        setUsers(response.data.data)
        const data = response.data.data.map(item => ({
          label: item.name,
          value: item.name
        }));
        setCustomers(data);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  /*const fetchChats = async () => {
    try {
      const response = await chatService.chats();
      if(response && response.data && response.data.length > 0){
        const data = response.data.map(item => ({
          label: item.name,
          value: item.id
        }));
        setChats(data);
      }
    } catch (error) {
      console.error('Error fetching chats:', error);
    }
  };*/

  const fetchServices = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.services(params);
      if(response && response.series && response.series.length > 0){
        const data = response.series.map(item => ({
          x: item.label,
          y: item.value
        }));
        setServices(data);
      }else{
        setServices([]);
      }
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const fetchRequests = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.requests(params);
      if(response && response.series && response.series.length > 0){
        const data = response.series.map(item => ({
          x: item.label,
          y: item.value
        }));
        setRequests(data);
      }else{
        setRequests([]);
      }
    } catch (error) {
      console.error('Error fetching requests:', error);
    }
  };

  return (
    <div className='services-charts-container'>
      <DashboardFilter 
        chartRef={chartRef}
        onApplyFilters={(filters) => {
          fetchServices(filters);
          fetchRequests(filters);
        }}
      />
      <div className="chart-wrapper-services" ref={chartRef}>
      <Donut 
          data={services}
          title="Total Services"
          height={170}
          width={400}
          innerRadius={40}
          outerRadius={80}
          colors={customColors}
        />
        <Donut 
          data={requests}
          title="Total Requests"
          height={170}
          width={400}
          innerRadius={40}
          outerRadius={80}
          colors={customColors}
        />
      </div>
    </div>
  )
}

export default ServicesCharts
